import { Avatar } from '@appkit4/react-components/avatar';
import { DropdownButton, ValueType } from '@appkit4/react-components/dropdown';
import { ItemDataType } from '@appkit4/react-components/filter';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import React, { SyntheticEvent, useState, useEffect } from 'react';
import { AppRoutes } from '../../Constants';
import useLocale from '../../locale/useLocale';

const AvatarDropdown = () => {
    const auth = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const { l } = useLocale();
    const [currentSelect, setCurrentSelect] = useState('' as ValueType);

    const handleSelect = (
        value: ValueType,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _item: ItemDataType,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _event: SyntheticEvent<Element, Event>
    ) => {
        navigate(`${value}`);
    };

    useEffect(() => {
        if (location.pathname === AppRoutes.SettingsPage) {
            setCurrentSelect(AppRoutes.SettingsPage);
        } else if (location.pathname === AppRoutes.Management) {
            setCurrentSelect(AppRoutes.Management);
        } else {
            setCurrentSelect('');
        }
    }, [location.pathname]);

    const data = [
        {
            label: l('_settings'),
            value: AppRoutes.SettingsPage,
            disabled: false,
            iconName: 'setting-outline',
        },
        {
            label: l('_logout'),
            value: AppRoutes.LogoutPage,
            disabled: false,
            iconName: 'logout-outline',
        },
    ];

    const getInitials = (): string => {
        let initials = '';
        initials += auth.user?.profile.given_name?.charAt(0) || '?';
        initials += auth.user?.profile.family_name?.charAt(0) || '?';
        return initials;
    };

    const prefixTemplate = (
        item: ItemDataType
    ): React.ReactNode | undefined => {
        if (item.iconName) {
            return (
                <span
                    className={`Appkit4-icon icon-${item.iconName as string}`}
                />
            );
        }
        return undefined;
    };

    const initials: string = getInitials();

    return (
        <DropdownButton
            data={data}
            splitButton={false}
            customTriggerClassName="custom-node"
            align="right"
            onSelect={handleSelect}
            customTriggerNode
            prefixTemplate={prefixTemplate}
            value={currentSelect}
        >
            <Avatar
                className={'avatar-cursor'}
                label={initials}
                ariaLabel={l('_navigationMenu')}
                disabled={true}
            />
        </DropdownButton>
    );
};

export default AvatarDropdown;
